import Vue from 'vue'
import Toast from '@/components/Toast/index.vue'

// export interface IOptions {
//   text?: string
//   icon?: string
//   loose?: boolean,
//   duration?: number,
// }
const ToastConstructor = Vue.extend(Toast)
export class ToastExtendConstructor extends ToastConstructor {
  close() {
    this.$props.value = false
    this.$off('input')
  }
}

let instance: ToastExtendConstructor
let defaultOptions: ISui.IToastOptions

const getInstance = () => {
  if (instance) return instance

  instance = new ToastExtendConstructor({
    el: document.createElement('div')
  })

  return instance
}

const toast = (options: string | ISui.IToastOptions) => {
  const vm = getInstance()

  if (!defaultOptions) {
    defaultOptions = { ...vm.$props }
  }

  let opts: ISui.IToastOptions
  if (typeof options === 'string') {
    opts = { ...defaultOptions, text: options }
  } else {
    opts = { ...defaultOptions, ...options }
  }

  Object.keys(opts).forEach((key) => {
    vm.$props[key] = opts[<keyof ISui.IToastOptions>key]
  })

  vm.$props.value = true
  vm.$off('input')
  vm.$on('input', (val: boolean) => {
    vm.$props.value = val
  })
  document.body.appendChild(vm.$el)

  return vm
}

export default toast
